import _objectSpread from "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import SidebarItem from "./SidebarItem";
import variables from '@/styles/variables.scss';
export default {
  components: {
    SidebarItem: SidebarItem
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['permission_routers', 'sidebar'])), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    // 从 SCSS 变量获取颜色
    menuBg: function menuBg() {
      return variables.menuBg || '#FFFFFF';
    },
    menuText: function menuText() {
      return variables.menuText || '#606266';
    },
    menuActiveText: function menuActiveText() {
      return variables.menuActiveText || '#FA8C16';
    }
  })
};